import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: '',
  components: {},
  props: {
    isLogin: {
      type: Boolean,
      default: false
    },
    saleSkuId: {
      type: [String, Number],
      default: ""
    },
    buyStatus: {
      type: Boolean,
      default: false
    },
    tipMessage: {
      type: String,
      default: ""
    },
    goodsDetail: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    itemPintuanInfoVo: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    shopNum: {
      type: Number,
      default: 0
    },
    newUser: {
      type: Boolean,
      default: false
    },
    newPrice: {
      type: String | Number,
      default: 0
    }
  },
  data: function data() {
    return {
      title: ''
    };
  },
  methods: {
    goIndex: function goIndex() {
      this.$reLaunch("member", "");
      this.$service.getStatisCommon("evn_close_page", {
        ed: {
          saleSkuId: this.saleSkuId
        }
      }, this.beforeDetail);
    },
    goCustom: function goCustom() {
      this.$navigateTo("customerService", {
        urlstr: "customerService"
      }); // this.$service.getStatisCommon("evn_close_page",{ed:{saleSkuId: this.saleSkuId}},this.beforeDetail);
    },
    goshopingCar: function goshopingCar() {
      // this.$router.push("/shoppingCar")
      // this.$router.push({ path:'/shoppingCar', query: { origin: "detail"}})
      this.$reLaunch("shoppingCar", {
        urlstr: "shoppingCar"
      });
    },
    immeBuy: function immeBuy(type) {
      this.$emit("immeBuy", type);
    },
    openGroup: function openGroup() {
      this.$emit("openGroup");
    },
    goOrderConfirm: function goOrderConfirm() {
      this.$emit('goOrderConfirm');
    }
  }
};